import React from "react";
import { ThemeProvider as BaseThemeProvider } from "styled-components";
import { makeBaseTheme } from "./baseTheme.js";
import { semanticColors } from "./colors.js";

export const ThemeProviderWithoutStore = ({ children }: React.PropsWithChildren) => {
  const theme = makeBaseTheme(semanticColors);
  return <BaseThemeProvider theme={theme}>{children}</BaseThemeProvider>;
};
